import http from "@/jslibs/axios/http";

// 文件上传
export const upload = file => {
    const params = new FormData();
    params.append('file', file);
    const config = {
        "Content-Type": "multipart/form-data;charset=utf-8",
    };
    return http.post('/v1/app/UploadFile', params, config);
}
// 上传文件专用接口
export const uploadFile = ({file}) => {
    const params = new FormData();
    params.append('file', file);
    const config = {
        "Content-Type": "multipart/form-data;charset=utf-8",
    };
    return http.post('/v1/app/UploadFile/file', params, config);
}
